<template>
  <div class="flex w-full mt-32">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img
        src="../../assets/images/pages/maintenance-2.png"
        alt="graphic-Maintenance"
        class="mx-auto mb-4 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">
        Sistema em Manutenção!
      </h1>
      <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
        Desculpe-nos pelo transtorno. Estamos trabalhando para melhor atendê-los.
      </p>
    </div>
  </div>
</template>
<script>
import service from '../../services'

export default {
  name: 'maintenance-Page',
  mounted(){
    service.maintenance(this.$router)
  }
};
</script>
<style></style>
